import { render, staticRenderFns } from "./select-cap-dialog.component.vue?vue&type=template&id=37a27144"
import script from "./select-cap-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./select-cap-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports